<template>
    <div class="corner-cell">
        <div class="row align-items-center" v-show="!showSearchForm">
            <div class="col">
                <span>{{ getTitle() }}</span>

                <template v-if="mode !== 'dailyPlanned' && mode !== 'projectPersons' && mode !== 'teamLead'">
                    <div class="dropdown sorting-drop-down">
                        <button
                            class="btn btn-transparent"
                            type="button"
                            @click.stop="toggleSortDropdown"
                        >
                            <i class="icofont-caret-down"></i>
                        </button>
                        <div class="dropdown-custom" v-if="showSortDropdown">
                            <button
                                type="button"
                                class="dropdown-item btn-sorting-drop-down-action d-flex justify-content-between"
                                v-for="(sort, key) in sorts"
                                :key="key"
                                @click.stop="setSort(sort.sort, sort.sortOrder)"
                            >
                                <span>
                                    <strong>{{ trans(sort.title) }}</strong>
                                    {{ sort.subTitle }}
                                </span>
                                <i class="icofont-check" v-if="isCurrentSort(sort)"></i>
                            </button>
                        </div>
                    </div>
                </template>
            </div>

            <template v-if="mode !== 'dailyPlanned' && mode !== 'teamLead'">
                <div class="col flex-grow-0">
                    <button type="button" class="btn btn-transparent" @click.stop="showSearch">
                        <i class="icofont-ui-search"></i>
                    </button>
                </div>
            </template>
        </div>
        <div class="row align-items-center" v-show="showSearchForm">
            <form
                class="corner-form col flex-grow-2 input-group pr-0"
                @submit.prevent="doSearch"
                @keydown.esc="hideSearch"
            >
                <input
                    type="text"
                    class="corner-form-input form-control"
                    ref="corner-form-input"
                    v-model="searchString"
                />
                <div class="input-group-append">
                    <button class="btn btn-primary" type="submit">
                        <i class="icofont-ui-search"></i>
                    </button>
                </div>
            </form>

            <div class="col flex-grow-0">
                <button type="button" class="btn btn-secondary" @click.stop="hideSearch">
                    <i class="icofont-close"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { MODE } from '../../constants';
import { mapActions, mapState } from 'vuex';

export default {
    data() {
        return {
            showSearchForm: false,
            searchString: '',
            showSortDropdown: false,
        };
    },
    props: {
        mode: {
            type: String,
            required: true,
            validator: function (value) {
                return Object.keys(MODE).indexOf(value) !== -1;
            },
        },
    },
    computed: {
        ...mapState('planning', {
            search: (state) => state.search,
            sort: (state) => state.sort,
            sortOrder: (state) => state.sortOrder,
        }),
        sorts() {
            return MODE[this.mode].sort;
        },
    },
    mounted() {
        document.addEventListener(
            'scroll',
            () => {
                this.closeSortDropdown();
            },
            true,
        );
        document.addEventListener('click', () => {
            this.closeSortDropdown();
        });
    },
    methods: {
        ...mapActions('planning', ['changeSort', 'changeSearch']),
        getTitle() {
            return trans(MODE[this.mode].title);
        },
        showSearch() {
            this.showSearchForm = true;
            this.$nextTick(() => {
                this.$refs['corner-form-input'].focus();
            });
        },
        hideSearch() {
            this.showSearchForm = false;
            const hadSearchString = !!this.searchString;
            this.searchString = '';
            if (hadSearchString) {
                this.doSearch();
            }
        },
        closeSortDropdown() {
            this.showSortDropdown = false;
        },
        toggleSortDropdown() {
            this.showSortDropdown = !this.showSortDropdown;
        },
        doSearch() {
            this.changeSearch({ search: this.searchString });
        },
        setSort(sort, sortOrder) {
            this.changeSort({ sort, sortOrder });
            this.closeSortDropdown();
        },
        isCurrentSort(sort) {
            return sort.sort === this.sort && sort.sortOrder === this.sortOrder;
        },
    },
    watch: {
        search(newSearch) {
            this.searchString = newSearch;
            if( this.searchString === '' ) {
                this.hideSearch();
            }
        }
    }
};
</script>

<style lang="scss">
.corner-cell {
    box-sizing: border-box;
    position: -webkit-sticky; /* for Safari */
    position: sticky;
    top: 0;
    left: 0;
    z-index: 999;
    width: 250px;
    line-height: 50px;
    border-right: 1px solid #ccc;
    background: #fff;
    padding: 0 10px;
}
.corner-form {
    height: 35px;
}
.corner-form-input:focus {
    border-color: #ced4da;
    box-shadow: none;
}
.dropdown-custom {
    .dropdown-item {
        line-height: 15px;
    }
}
</style>
